import { Data2Service } from '@/common/data2.service';
import { DateService } from '@/common/date.service';
import { Component, effect, input, Input, model } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';

import { FiltersComponent } from '@/common/filters.component';
import { OfferTransportKind } from '@/common/enums/OfferTransportKind';
import { User } from '../transport-assign-dialog/transport-assign-dialog.component';

interface FilterDefinition {
	[key: string]: {
		type: string;
		isArray: boolean;
	};
}

type OfferTransportKindMap = { key: OfferTransportKind; label: string };

const offerTransportKindsStrict: Record<Exclude<OfferTransportKind, OfferTransportKind.BOTH>, OfferTransportKindMap> = {
	[OfferTransportKind.PLANE]: { key: OfferTransportKind.PLANE, label: 'Samolot' },
	[OfferTransportKind.COACH]: { key: OfferTransportKind.COACH, label: 'Autokar' },
};

@Component({
	selector: 'app-bag-transport-filters',
	templateUrl: './bag-transport-filters.component.html',
	styleUrls: ['./bag-transport-filters.component.scss'],
})
export class BagTransportFiltersComponent extends FiltersComponent {
	@Input() yesno: Array<boolean>;
	@Input() names: Array<string[]>;
	@Input() statuses: Array<string[]>;

	readonly allUsers = input.required<User[]>();

	readonly offerTransportKinds: OfferTransportKindMap[] = Object.values(offerTransportKindsStrict);

	readonly showAdvanced = model(false);

	constructor(
		protected api: Data2Service,
		protected route: ActivatedRoute,
		protected router: Router,
		protected _snackBar: MatSnackBar,
	) {
		super(api, route, router);
		effect(() => {
			if (this.showAdvanced()) {
				return;
			}

			this.filters = {
				...this.filters,
				departure_time_after: null,
				departure_time_before: null,
				return_time_after: null,
				return_time_before: null,
			};
		});
	}

	setDefaultFilters(): void {
		const dateService = new DateService();
		this.filters.departure_time_after = dateService.addDays(-7, dateService.now().date);
		this.filters.departure_time_before = dateService.addDays(14, dateService.now().date);
		this._snackBar.open('Ustawiono domyślne filtry', 'Zamknij', {
			duration: 4000,
		});
		this.filtersSave();
	}

	filtersAfterLoad(): void | boolean {
		const filtered = Object.keys(this.filters)
			.filter((key) => !['limit', 'on'].includes(key))
			.reduce((obj, key) => {
				obj[key] = this.filters[key];
				return obj;
			}, {});
		for (const key in filtered) {
			if (filtered[key] !== null && filtered[key] != '') return false;
		}
		return this.setDefaultFilters();
	}

	filtersClear(): void {
		for (const key in this.filters) {
			if (Array.isArray(this.filters[key])) {
				this.filters[key] = [];
				continue;
			}
			this.filters[key] = null;
		}
	}

	setFiltersDefinition(filtersDefinition: FilterDefinition): void {
		this.filtersDefinition = filtersDefinition;
	}
}
